exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  background: #f6f6f6;\n  color: #111;\n  display: block;\n  font-size: 1.3em;\n  height: 50px;\n  overflow: hidden;\n  position: relative; }\n  .header .back-button {\n    color: #5cc42d;\n    cursor: pointer;\n    font-size: 1.5em;\n    left: 15px;\n    line-height: 50px;\n    position: absolute;\n    top: 0;\n    z-index: 1; }\n  .header .title {\n    line-height: 50px;\n    text-align: center; }\n  .header .extra-function {\n    color: #5cc42d;\n    cursor: pointer;\n    line-height: 50px;\n    position: absolute;\n    right: 15px;\n    top: 1px;\n    z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/header/header.component.scss
// module id = ../../../../../src/app/Components/header/header.component.scss
// module chunks = 1